export default "__VITE_ASSET__BGXzP_p6__"